export default __webpack_public_path__ + "i18n/translations/translation-cs.6ba9eca4.json";